import { useCallback, useEffect, useState } from "react";
import { PageTitle, PageTitleContainer } from "@/ui-components/utils/menu-items/page-title";
import useApiRequest from "@/lib/hooks/use-request";
import { Link } from "react-router-dom";
import { Button } from "@/ui-components/ui/button";
import { Plus } from "lucide-react";
import { useBreadcrumb } from "@/ui-components/ui/breadcrumb/breadcrumb-context";

const Pipelines = () => {
  const { apiRequest } = useApiRequest();
  const { setTitle } = useBreadcrumb();
  const [pipelines, setPipelines] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (setTitle) {
      setTitle("Pipelines");
    }
  }, [setTitle]);

  const fetchPipelines = useCallback(async () => {
    setLoading(true);
    const res = await apiRequest<any>("pipelines/search", "GET");
    setLoading(false);
    if (res.data) {
      // The search endpoint returns paginated data
      setPipelines(res.data.docs || []);
    }
  }, [apiRequest]);

  useEffect(() => {
    fetchPipelines();
  }, [fetchPipelines]);

  return (
    <div>
      <PageTitleContainer>
        <div className="flex flex-row justify-between items-center">
          <PageTitle>Pipelines</PageTitle>
          <Link to="/pipelines/create">
            <Button>
              <Plus size={16} className="mr-2" />
              Neue Pipeline
            </Button>
          </Link>
        </div>
      </PageTitleContainer>

      <div className="p-4">
        {loading ? (
          <div className="text-center py-8">
            <div className="text-gray-500">Loading pipelines...</div>
          </div>
        ) : pipelines.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {pipelines.map((pipeline) => (
              <Link to={`/pipelines/${pipeline._id}`} key={pipeline._id} className="block">
                <div className="border rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow hover:bg-gray-50">
                  <h3 className="text-lg font-semibold mb-2">{pipeline.title}</h3>
                  <div className="space-y-1 text-sm text-gray-600">
                    <p>Benutzer: {pipeline.belongsToUserIds?.length || 0}</p>
                    <p>Phasen: {pipeline.stages?.length || 0}</p>
                    {pipeline.wordpressId && (
                      <p>WordPress ID: {pipeline.wordpressId}</p>
                    )}
                  </div>
                  <p className="text-xs text-gray-500 mt-2">
                    Erstellt: {pipeline.createdAt ? new Date(pipeline.createdAt).toLocaleDateString('de-DE') : '-'}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        ) : (
          <div className="text-center py-8">
            <p className="text-gray-500">Keine Pipelines gefunden.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Pipelines;